export class Enterprise
{
id: number;
name : string;
label : string;
detailsLink : string;
rulesLink : string;
}
